import React, { useState } from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { testimonialsHomePageText } from "i18n/homePage";
import { Info, TrendingUp } from "lucide-react";
import CTAButton from "Util/CTAButton";

const Mentorship = () => {
  const navigate = useNavigate();
  const lang = useSelector((state) => state.language.lang);
  const t = testimonialsHomePageText[lang];
  const [activeCard, setActiveCard] = useState(null);

  const getPositionClass = (position) => {
    switch (position) {
      case "leftTop":
        return "items-start justify-start text-left pt-8 pl-8";

      case "rightTop":
        return "items-end justify-start text-right pt-8 pr-8";
      case "leftBottom":
        return "items-start justify-end text-left pb-8 pl-8";
      case "rightBottom":
        return "items-end justify-end text-right pb-8 pr-8";
      default:
        return "items-center justify-center text-center";
    }
  };

  return (
    <section className="py-6 bg-darkbg px-6 text-white overflow-hidden">
      {/* SECTION TITLE */}
      {/* CARDS */}
      <div className="mx-auto grid md:grid-cols-3 gap-8">
        {t.cards.map((card, i) => (
          <motion.div
            key={i}
            onClick={() => setActiveCard(activeCard === i ? null : i)}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            transition={{ delay: i * 0.2 }}
            className="cursor-pointer group"
          >
            {/* IMAGE CARD */}

            <div className="relative h-[270px] md:h-[450px] overflow-hidden object-top">
              <div className="absolute top-0 left-0 w-full h-2  z-20 overflow-hidden">
                <div
                  className="
      h-full
      w-full
      bg-gradient-to-r
      from-reddark
      via-red-500
      to-reddark
      origin-left
      scale-x-0
      group-hover:scale-x-100
      transition-transform
      duration-700
      ease-out
    "
                />
              </div>
              <div className="relative w-full h-full overflow-hidden object-top">
                <img
                  src={card.photo}
                  alt={card.title}
                  className="
      absolute inset-x-0 object-top
      w-full h-full
      object-cover
      transition-transform duration-700
      group-hover:scale-110
    "
                />
              </div>
              {card.favourite && (
                <div
                  className="
      absolute top-4 right-4 z-30
      flex items-center gap-1.5
      px-3 py-1.5
      rounded-full
      bg-reddark
      text-white
      text-xs font-semibold
      uppercase tracking-wider
      shadow-lg
      border border-white/20
      backdrop-blur-sm
    "
                >
                  <TrendingUp
                    size={14}
                    className="fill-amber-400 text-amber-400"
                  />
                  <span>{card.favourite}</span>
                </div>
              )}
              {/* DARK OVERLAY */}
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/80 transition group-hover:text-reddark" />

              {/* CENTER TEXT */}
              <div
                className={`absolute inset-0 flex flex-col
    text-white
    transition-colors duration-300
    group-hover:text-reddark
    ${getPositionClass(card.position)}
  `}
              >
                <div
                  className="      mt-6
      opacity-0
      translate-y-4
      group-hover:opacity-100
      group-hover:translate-y-0
      transition-all duration-500 delay-100
      pointer-events-none
      group-hover:pointer-events-auto"
                >
                  <h3 className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase leading-none tracking-wide ">
                    {card.title}
                  </h3>

                  <p className="text-3xl md:text-4xl font-[Crimson] italic mt-2">
                    {card.subtitle}
                  </p>

                  {/* <p className="mt-2">{card.quote}</p> */}
                </div>
                <div
                  className="
      mt-6
      opacity-0
      translate-y-4
      group-hover:opacity-100
      group-hover:translate-y-0
      transition-all duration-500 delay-100
      pointer-events-none
      group-hover:pointer-events-auto
    "
                >
                  <CTAButton
                    variant="primary"
                    icon={Info}
                    text="Learn More"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(card.path);
                    }}
                  />
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Mentorship;
